import { render, staticRenderFns } from "./OutbreakAlertPrompt.vue?vue&type=template&id=bc757356&scoped=true&"
import script from "./OutbreakAlertPrompt.vue?vue&type=script&lang=js&"
export * from "./OutbreakAlertPrompt.vue?vue&type=script&lang=js&"
import style0 from "./OutbreakAlertPrompt.vue?vue&type=style&index=0&id=bc757356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc757356",
  null
  
)

export default component.exports